export const VERIFIED_PHONE_CREDIT_CENTS = 500; // $5
export const VERIFIED_PHONE_CREDIT_STR = `$${VERIFIED_PHONE_CREDIT_CENTS / 100}`;
